export default __webpack_public_path__ + "static/media/longshot-web.f6e2e85d.jpg";